<template>
  <v-layout align-space-around justify-start fill-height column class="pt-5">
    <div class="pt-2">
      <v-toolbar
        class="elevation-0 secondary--text"
        style="background: transparent"
      >
        <v-toolbar-title>Fale com a Apetrus</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom lazy>
          <template v-slot:activator="{ on }">
            <v-btn flat icon v-on="on" @click="sendEmail" color="primary">
              <v-icon>send</v-icon>
            </v-btn>
          </template>
          <span>Enviar</span>
        </v-tooltip>
      </v-toolbar>
      <v-card flat>
        <v-form>
          <v-autocomplete
            v-model="mail.to"
            :items="['contato@apetrus.com.br']"
            chips
            label="Para"
            readonly
            full-width
            hide-details
            hide-no-data
            hide-selected
            single-line
          ></v-autocomplete>
          <v-divider></v-divider>
          <v-select
            label="Assunto"
            v-model="mail.assunto"
            :items="assuntos"
            full-width
            hide-details
          >
          </v-select>
          <v-divider></v-divider>
          <v-text-field
            v-model="email"
            label="Seu e-mail"
            hint="Ele será usado para que possamos entrar em contato posteriormente"
            full-width
            persistent-hint
          ></v-text-field>
          <v-divider></v-divider>
          <v-textarea
            v-model="mensagem"
            label="Mensagem"
            counter
            maxlength="120"
            full-width
            single-line
          ></v-textarea>
        </v-form>
      </v-card>
    </div>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="4000"
      :vertical="true"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      snackbar: {
        active: false,
        color: 'info',
        text: ''
      },
      email: null,
      mensagem: null,
      assuntos: [
        'Tenho uma dúvida',
        'Tenho uma sugestão',
        'Quero conhecer a Apetrus'
      ],
      mail: {
        message: '',
        assunto: '',
        to: 'contato@apetrus.com.br'
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    if (this.user) {
      this.email = this.user.email
    }
  },
  watch: {
    user (val) {
      if (val) {
        this.email = this.val.email
      }
    }
  },
  methods: {
    limparCampos () {
      this.email = null
      this.mensagem = null
      this.mail = {
        message: '',
        assunto: '',
        to: 'contato@apetrus.com.br'
      }
    },
    sendEmail () {
      this.mail.message = `Apetrus Postos <br/>Email: ${this.email}<br/> ${this.mensagem}`
      this.$store.dispatch('sendContactMail', this.mail).then(() => {
        this.limparCampos()
        this.email = this.user.email
        this.snackbar.color = 'info'
        this.snackbar.text = 'Email enviado com sucesso'
        this.snackbar.active = true
      }).catch((error) => {
        this.snackbar.color = 'error'
        this.snackbar.text = error
        this.snackbar.active = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
